import React from 'react';
import { Title, ActionButton, ActionLink } from '@/components/atoms/Section';
import ItemArrowUp from '@/components/svg/ItemArrowUp';
import ItemArrowDown from '@/components/svg/ItemArrowDown';
import { GridAction } from '@/components/molecules/section/Grid';
import styles from './Head.module.scss';

const View: React.FC<{
  title: string;
  actions: GridAction[];
  open: boolean;
  setOpen: (open: boolean) => void;
}> = ({ title, actions, open, setOpen }) => {
  const icon = open ? <ItemArrowDown className={styles.icon} /> : <ItemArrowUp className={styles.icon} />;
  return (
    <div
      className={styles.container}
      onClick={() => setOpen(!open)}
    >
      <div className={styles.title}>
        <Title label={title} />
      </div>
      <div className={styles.actions}>
        {actions.map((action, index) => {
          if (action.kind === 'Button') {
            return (
              <ActionButton
                key={index}
                label={action.label}
                onClick={action.onClick}
                disabled={action.disabled}
                dataCy={`action-button`}
              />
            );
          } else {
            return (
              <ActionLink
                key={index}
                label={action.label}
                url={action.url}
                newTab={action.newTab}
                onClick={action.onClick}
                disabled={action.disabled}
                dataCy={`action-button`}
              />
            );
          }
        })}
      </div>
      <div
        data-cy={`action-button`}
        className={styles.iconWrapper}
      >
        {icon}
      </div>
    </div>
  );
};

export default View;
